export default "__VITE_ASSET__B$utKjIv__"